<template>
  <BasicLayout>
    <template #wrapper>
      <el-card :bordered="false" :body-style="{padding: '0'}">
        <div class="salesCard">
          <el-form :inline="true">
            <el-form-item label="平台" prop="platForm">
              <el-select v-model="queryParams.platForm" size="small" style="width: 130px" placeholder="请选择">
                <el-option
                  v-for="item in platForm"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="国家" prop="startDate">
              <el-select v-model="queryParams.country" filterable size="small" style="width: 130px" placeholder="请选择">
                <el-option
                  v-for="item in country"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="开始日期">
              <el-date-picker
                v-model="queryParams.startDate"
                placeholder="请选择日期"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                style="width: 150px"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item label="结束日期">
              <el-date-picker
                v-model="queryParams.endDate"
                placeholder="请选择日期"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                size="small"
                style="width: 150px"
                @keyup.enter.native="handleQuery"
              />
            </el-form-item>
            <el-form-item>
              <el-button :loading="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
              <el-button v-if="exportShow" type="primary" icon="el-icon-search" size="mini" @click="exportData">导出</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div ref="chartContainer" style="width: 100%; height: 400px;" />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getIndexPayData } from '@/api/statistics/user_remain'
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'IndexPayData',
  props: {
    startDate: {
      type: String,
      default: ''
    },
    endDate: {
      type: String,
      default: ''
    },
    exportShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      platForm: [{ label: '全部', value: 0 }, { label: '安卓', value: 1 }, { label: '苹果', value: 2 }, { label: 'TG', value: 3 }],
      country: [],
      chartData: {},
      queryParams: {
        platForm: '',
        country: '',
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        type: 1
      },
      options: [],
      tableData: [],
      date: [],
      chart: {},
      option: {}
    }
  },
  watch: {
    startDate(newVal, oldVal) {
      this.getTables()
    }
  },
  created() {
    this.getTables()
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleKeyUp() {
      this.onSubmit()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能与结束日期')
        return
      }

      this.getTables()
    },
    getTables() {
      this.loading = true
      this.queryParams.type = 1
      getIndexPayData(this.queryParams).then(res => {
        this.loading = false
        this.chart.hideLoading()
        if (res.code === 200) {
          this.queryParams.startDate = res.data.req.startDate
          this.queryParams.endDate = res.data.req.endDate
          const country = res.data.country
          this.country = [{ value: '', label: '全部' }]
          for (const i in country) {
            this.country.push({ value: i, label: country[i] })
          }
          const chartData = {
            price: [],
            payCount: [],
            payUser: [],
            payRate: [],
            regPayRate: [],
            actPayRate: [],
            arppu: [],
            arpu: []
          }
          this.date = []
          res.data.data.forEach((item) => {
            this.date.push(dateStrTodate(item.date))
            chartData.price.push(item.price)
            chartData.payCount.push(item.pay_count)
            chartData.payUser.push(item.pay_user)
            chartData.regPayRate.push(item.reg_pay_rate)
            chartData.actPayRate.push(item.act_pay_rate)
            let pay = 0
            let arppu = 0
            let arpu = 0
            if (item.log_count > 0) {
              pay = (item.pay_user / item.log_count * 100).toFixed(2)
            }
            if (item.pay_user > 0) {
              arppu = (item.price / item.pay_user).toFixed(2)
            }
            if (item.log_count > 0) {
              arpu = (item.price / item.log_count).toFixed(2)
            }
            chartData.payRate.push(pay)
            chartData.arppu.push(arppu)
            chartData.arpu.push(arpu)
          })
          console.log('chartData', chartData)
          this.option.xAxis.data = this.date
          this.option.series[0].data = chartData.price
          this.option.series[1].data = chartData.payCount
          this.option.series[2].data = chartData.payUser
          this.option.series[3].data = chartData.regPayRate
          this.option.series[4].data = chartData.actPayRate
          this.option.series[5].data = chartData.payRate
          this.option.series[6].data = chartData.arppu
          this.option.series[7].data = chartData.arpu
          this.chart.setOption(this.option)
          this.queryParams = res.data.req
        } else {
          this.msgError(res.msg)
        }
      })
    },
    numFormatter(row, column, cellValue, index) {
      return cellValue + '%'
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.chart.showLoading()
      this.option = {
        title: {
          text: '付费数据'
        },
        xAxis: {
          name: '',
          type: 'category',
          data: []
        },
        legend: {
          // data: ['每日收入', '成功订单数', '7日', '30日']
          x: 'center',
          y: 'bottom',
          selected: {
            '当日收入': true,
            '支付人数': true,
            '支付订单数': true,
            '注册付费率': false,
            '活跃付费率': false,
            '付费率': false,
            'ARPPU': true,
            'ARPU': true
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [
          { type: 'value', axisLabel: { formatter: '{value}' }, axisLine: {
            show: false // 隐藏 y 轴的竖线
          }},
          { type: 'value', axisLabel: { formatter: '{value}%' }, position: 'right', axisLine: {
            show: false // 隐藏 y 轴的竖线
          }}
        ],
        toolbox: {
          show: true,
          feature: {
            // dataView: { readOnly: false },
            // magicType: { type: ['line', 'bar'] },
            // restore: {},
            // saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '当日收入',
            data: [],
            type: 'line',
            smooth: true,
            markPoint: {
              // data: [
              //   { type: 'max', name: 'Max' },
              //   { type: 'min', name: 'Min' }
              // ]
            },
            label: {
              show: true,
              position: 'left', // 标签显示在折线图顶部
              formatter: '${c}' // 显示数值
            }
          },
          {
            name: '支付订单数',
            data: [],
            type: 'line',
            smooth: true,
            markPoint: {
              // data: [
              //   { type: 'max', name: 'Max' },
              //   { type: 'min', name: 'Min' }
              // ]
            },
            label: {
              show: true,
              position: 'right', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '支付人数',
            data: [],
            type: 'line',
            smooth: true,
            markPoint: {
              // data: [
              //   { type: 'max', name: 'Max' },
              //   { type: 'min', name: 'Min' }
              // ]
            },
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            },
            itemStyle: {
              normal: {
                color: '#00BFFF' // 改变线条颜色
              }
            }
          },
          {
            name: '注册付费率',
            data: [],
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '活跃付费率',
            data: [],
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '付费率',
            data: [],
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: 'ARPPU',
            data: [],
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '${c}' // 显示数值
            }
          },
          {
            name: 'ARPU',
            data: [],
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '${c}' // 显示数值
            }
          }
        ]
      }
      this.chart.setOption(this.option)
    },
    handleClick(params) {
      const clickName = params.name
      const selected = params.selected
      if (this.reelectionName === '') {
        this.reelectionName = clickName
        this.reelectionClick++
      } else if (this.reelectionName !== clickName) {
        this.resetLegend(selected)
        return
      }

      if (this.reelectionClick > 2 && this.reelectionName === clickName) {
        this.resetLegend(selected)
        return
      }

      this.reelectionClick++
      const reelection = this.reelection
      for (const i in selected) {
        if (i === clickName) {
          selected[i] = !reelection
        } else {
          selected[i] = reelection
        }
      }
      this.reelection = !reelection
      this.chart.setOption({
        legend: {
          selected: selected
        }
      })
    },
    resetLegend(selected) {
      for (const i in selected) {
        selected[i] = true
      }
      this.reelectionName = ''
      this.reelection = false
      this.chart.setOption({
        legend: {
          selected: selected
        }
      })
      this.reelectionClick = 0
    },
    exportData() {
      this.queryParams.type = -1
      getIndexPayData(this.queryParams).then(res => {
        window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
      })
    }
  }
}
</script>

<style scoped>
</style>
